import React from 'react'
import styled from 'styled-components'
import theme from 'vars/theme'
const Button = styled.button`
  display: inline-block;
  width: 160px;
  height: 80px;
  border: 1px solid #ccc;
  color: #247cdb;
  background-color: white;
  font-size: 48px;
  border-radius: 12px;
  margin-bottom: 8px;
  font-weight: bold;
  line-height: 1;
  text-align: center;
  padding: 1px 6px;
  white-space: nowrap;
`
const ButtonSp = styled.button`
  display: inline-block;
  height: 56px;
  border: 1px solid ${theme.grayMedium3};
  color: ${theme.blueMedium5};
  background-color: white;
  font-size: 20px;
  border-radius: 4px;
  margin-bottom: 8px;
  font-weight: bold;
  line-height: 1;
  text-align: center;
  padding: 1px 6px;
  white-space: nowrap;
`

const CustomNumberButton = styled(Button)`
  opacity: ${({ disabled }) => (disabled ? 0.2 : 1.0)};
`

const CustomNumberButtonSp = styled(ButtonSp)`
  opacity: ${({ disabled }) => (disabled ? 0.2 : 1.0)};
`

export default ({
  isShowPhoneNumberPrefix = false,
  onClick,
  onClickBackSpace,
  onClickEnter,
  value,
  canClickEnter = false,
  isSp = false,
  enterButtonDgId = undefined
}) => {
  if (isSp) {
    return (
      <div
      className="mx-auto"
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
      }}
      >
      {/* top */}
      {isShowPhoneNumberPrefix && (
        <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(4, 1fr)',
          gap: 8,
          width: '100%',
          marginBottom: 24,
        }}
        >
        <CustomNumberButtonSp onClick={() => onClick('070')} disabled={value.length}>
          070
        </CustomNumberButtonSp>
        <CustomNumberButtonSp onClick={() => onClick('080')} disabled={value.length}>
          080
        </CustomNumberButtonSp>
        <CustomNumberButtonSp onClick={() => onClick('090')} disabled={value.length}>
          090
        </CustomNumberButtonSp>
        </div>
      )}

      {/* center */}
      <div
        style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(4, 1fr)',
        gridTemplateRows: 'repeat(4, 56px)', // 2 rows, each 56px high
        gap: 8,
        width: '100%',
        marginBottom: 8,
        }}
      >
        <ButtonSp onClick={() => onClick('1')} style={{ gridRow: '1', gridColumn: '1' }}>1</ButtonSp>
        <ButtonSp onClick={() => onClick('2')} style={{ gridRow: '1', gridColumn: '2' }}>2</ButtonSp>
        <ButtonSp onClick={() => onClick('3')} style={{ gridRow: '1', gridColumn: '3' }}>3</ButtonSp>

        <ButtonSp onClick={() => onClick('4')} style={{ gridRow: '2', gridColumn: '1' }}>4</ButtonSp>
        <ButtonSp onClick={() => onClick('5')} style={{ gridRow: '2', gridColumn: '2' }}>5</ButtonSp>
        <ButtonSp onClick={() => onClick('6')} style={{ gridRow: '2', gridColumn: '3' }}>6</ButtonSp>

        <ButtonSp onClick={() => onClick('7')} style={{ gridRow: '3', gridColumn: '1' }}>7</ButtonSp>
        <ButtonSp onClick={() => onClick('8')} style={{ gridRow: '3', gridColumn: '2' }}>8</ButtonSp>
        <ButtonSp onClick={() => onClick('9')} style={{ gridRow: '3', gridColumn: '3' }}>9</ButtonSp>
        <ButtonSp onClick={() => onClick('0')} style={{ gridRow: '4', gridColumn: '2' }}>0</ButtonSp>

        <ButtonSp
          style={{
            gridRow: '1',
            gridColumn: '4',
            fontSize: 16,
            fontWeight: 700,
            lineHeight: 1.5,
          }}
          onClick={onClickBackSpace}>
          一文字<br />消す
        </ButtonSp>
        <ButtonSp
          style={{
            color: 'white',
            backgroundColor: theme.blueMedium5,
            border: 'none',
            height: 'calc(56px * 2 + 8px)',// Span 2 rows height-wise
            fontSize: 16,
            fontWeight: 700,
            lineHeight: 1.5,
            opacity: canClickEnter ? 1.0 : 0.2,
            gridRow: '2 / span 2', // 2行目〜3行目に表示
            gridColumn: '4',
          }}
          disabled={!canClickEnter}
          onClick={onClickEnter}
          data-dg-id={enterButtonDgId}>
          決定
        </ButtonSp>
      </div>
    </div>
      )
  }
  return (
    <div
      className="mx-auto"
      style={{
        width: isShowPhoneNumberPrefix ? 832 : 664,
        display: 'flex',
        justifyContent: 'space-between',
      }}
    >
      {/* left */}
      {isShowPhoneNumberPrefix && (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <CustomNumberButton onClick={() => onClick('070')} disabled={value.length}>
            070
          </CustomNumberButton>
          <CustomNumberButton onClick={() => onClick('080')} disabled={value.length}>
            080
          </CustomNumberButton>
          <CustomNumberButton onClick={() => onClick('090')} disabled={value.length}>
            090
          </CustomNumberButton>
        </div>
      )}

      {/* center */}
      <div style={{ width: 496 }}>
        <div>
          <Button style={{ marginRight: 8 }} onClick={() => onClick('1')}>
            1
          </Button>
          <Button style={{ marginRight: 8 }} onClick={() => onClick('2')}>
            2
          </Button>
          <Button onClick={() => onClick('3')}>3</Button>
        </div>
        <div>
          <Button style={{ marginRight: 8 }} onClick={() => onClick('4')}>
            4
          </Button>
          <Button style={{ marginRight: 8 }} onClick={() => onClick('5')}>
            5
          </Button>
          <Button onClick={() => onClick('6')}>6</Button>
        </div>
        <div>
          <Button style={{ marginRight: 8 }} onClick={() => onClick('7')}>
            7
          </Button>
          <Button style={{ marginRight: 8 }} onClick={() => onClick('8')}>
            8
          </Button>
          <Button onClick={() => onClick('9')}>9</Button>
        </div>
        <div>
          <Button style={{ marginLeft: 168 }} onClick={() => onClick('0')}>
            0
          </Button>
        </div>
      </div>

      {/* right */}
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <Button style={{ fontSize: 22, fontWeight: 'normal' }} onClick={onClickBackSpace}>
          一文字消す
        </Button>
        <Button
          style={{
            color: 'white',
            backgroundColor: theme.blueMedium5,
            border: 'none',
            height: 256,
            fontWeight: 'normal',
            opacity: canClickEnter ? 1.0 : 0.2,
          }}
          disabled={!canClickEnter}
          onClick={onClickEnter}
          data-dg-id={enterButtonDgId}
        >
          決定
        </Button>
      </div>
    </div>
  )
}
